import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import ElementForm from '../components';
import { getElementById } from '../../../modules/elements/actions';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.initiatives || {},
    element: state.elements.element,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getElementById: bindActionCreators(getElementById, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ElementForm));



// WEBPACK FOOTER //
// ./src/routes/ElementForm/container/index.js